import React from "react";
//Style
import { Container, Img, Logo, Item, ItemGroup, IconCall } from "./style";
import { useHistory } from "react-router-dom";
const Header = () => {
  const history = useHistory();
  return (
    <Container>
      <Logo
        onClick={() => {
          history.replace("/");
        }}
      >
        <Img src="https://bonnadona-public.s3.amazonaws.com/assets/logo_hfv9aa.png" />
      </Logo>
      <ItemGroup>
        <Item href="tel:+573165258090">
          <IconCall />
          +57 316 525 8090
        </Item>
        <Item>Servicio de atencion</Item>
      </ItemGroup>
    </Container>
  );
};

export default Header;
